<div id="breadcrumb" class="col-xs-12 col-md-6">
    <ol class="breadcrumb">
<li>
<a routerLink='/'>Home</a>
</li>

<li class="bc_bold"><strong>Create Account</strong></li>
</ol>
</div>
